package com.tregz.tremenz.ui.label

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.tregz.polyglot.PolyglotManager

private val polyglot by lazy {
    PolyglotManager(
        collectionPath = "strings",
        documentPrefix = "tremenz-",
        version = LabelKey.VERSION,
        defaultStrings = LabelKey.defaults
    )
}

@Composable
actual fun labelText(key: LabelKey): String {
    val strings by polyglot.strings.collectAsState()
    return strings[key.name] ?: LabelKey.defaults[key.name] ?: key.name
}
